<template>
  <div class="stack">
    <div class="stack__list">
      <AvatarBorder
        v-for="image in avatarList"
        :key="image"
        class="stack__item"
        :src="`${image}`" 
        :size="36"
        :borderSize="2" 
        :borderColor="'var(--bg-primary)'"
      />
    </div>
    <span class="stack__counter">
      <ActiveBellIcon /> {{ notificationsCount }}
    </span>
  </div>
</template>

<script setup>
  import { useNotificationsState } from '@/Groups/Notifications/private/composables/computedValues';
  //-------------------------------------
  import ActiveBellIcon from '@/Groups/Notifications/private/svg/ActiveBellIcon.vue';
  import { AvatarBorder } from '@/Groups/Notifications/private/imports/externalTemplates';
  //-------------------------------------
  const { avatarList, notificationsCount } = useNotificationsState();
</script>

<style lang="scss" scoped>
  @import './styles.scss';
</style>